/* eslint-disable @typescript-eslint/no-unused-vars */
import { Theme } from '@mui/material';

import { makeStyles } from '@mui/styles';

export const DEFAULT_NAV_PADDING = 8;

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  toolbar: {
    marginTop: '5px',
  },

  container: {
    padding: `${spacing(2)} 0`,
    display: 'flex',
    flex: '1',
    flexDirection: 'column',
  },  

  options: {
    padding: `${spacing(2)} ${DEFAULT_NAV_PADDING}px 0 ${DEFAULT_NAV_PADDING}px`,
    display: 'flex',
  },
}));

export default useStyles;
